<script>
  export let department;
  export let emoji;
</script>

<div>
  <img src="./images/emojis/{emoji}.png" alt="Icon for {department}" />
  <h1>{department}</h1>
</div>

<style>
  div {
    flex: 1;
    margin: 0 0.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    place-items: center;
  }

  img {
    width: 50%;
  }

  h1 {
    font-size: 1.5rem;
    text-align: center;
    font-family: var(--font-serif);
    margin-top: 1.75rem;
    font-weight: 400;
  }

  @media screen and (max-width: 568px) {
    img {
      width: 60px;
    }

    h1 {
      font-size: 0.8rem;
    }
  }
</style>
